<script setup>
import { useBIDatasetPicker } from '~/bi/composables/useBIDatasetPicker.js';

const props = defineProps({
  allSchemas: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['selected', 'selectedSeries']);
const $t = inject('$t');
const items = [{
  name: $t('Recent'),
  value: 'recent',
}, {
  name: `${$t('All Datasets')} (${props.allSchemas.length})`,
  value: 'all_dataset',
}, {
  name: $t('Generate series'),
  value: 'generate_series',
}, { name: $t('Upload'), value: 'upload' }];

const { store_table_in_local_storage, get_tables_from_local_storage } = useBIDatasetPicker();

const recent = get_tables_from_local_storage();

const selected_item = ref(recent?.length > 0 ? items[0] : items[1]);

function selectTable(table) {
  store_table_in_local_storage({ type: 'Data source', name: table.name });
  emit('selected', table);
}

function selectSeries(data) {
  emit('selectedSeries', data);
}

function selectRecent(data) {
  if (data.type === 'Data source')
    emit('selected', data);
  else if (data.type === 'Series')
    emit('selectedSeries', data);
}
</script>

<template>
  <div class="flex p-4">
    <div class="w-[200px] h-fit bg-gray-50 border border-gray-100 rounded-md text-sm font-regular text-gray-600 px-2 py-3">
      <div v-for="item in items" :key="item.value" class="p-3 cursor-pointer rounded-md" :class="{ 'bg-gray-700 text-white': selected_item.value === item.value }" @click="selected_item = item">
        {{ item.name }}
      </div>
    </div>
    <div class="flex-1 max-h-[calc(100vh-120px)] overflow-auto">
      <div v-if="selected_item.value === 'generate_series'">
        <bi-dataset-picker-series @save="selectSeries" />
      </div>
      <div v-else-if="selected_item.value === 'upload'">
        <bi-dataset-picker-upload @published="selected_item = items[1]" />
      </div>
      <div v-else-if="selected_item.value === 'recent'" class="h-full">
        <div v-if="recent?.length === 0" class="text-sm font-medium text-gray-700 flex items-center justify-center h-full">
          {{ $t('No recent datasets') }}
        </div>
        <bi-dataset-picker-recent v-else :recent="recent" :all-schemas="allSchemas" @selected="selectRecent" />
      </div>
      <div v-else>
        <div v-if="allSchemas.length === 0" class="text-sm font-medium text-gray-700 flex items-center justify-center h-full">
          {{ $t('No datasets found') }}
        </div>
        <bi-dataset-picker-table :all-schemas="allSchemas" @selected="selectTable" />
      </div>
    </div>
  </div>
</template>
